var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Portal, Popover as ChakraPopover, PopoverArrow, PopoverTrigger, PopoverContent, PopoverHeader, PopoverFooter, PopoverBody, PopoverCloseButton, } from "@chakra-ui/react";
const Popover = forwardRef((_a, ref) => {
    var { isLazy = true } = _a, props = __rest(_a, ["isLazy"]);
    return (React.createElement(ChakraPopover, Object.assign({}, props, { isLazy: isLazy })));
});
export { Portal, Popover, PopoverArrow, PopoverTrigger, PopoverContent, PopoverHeader, PopoverFooter, PopoverBody, PopoverCloseButton, };
//# sourceMappingURL=Popover.js.map